// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8335) return "OrderDetailsPage-8b7f128308959d0c9e02.css";
	if (chunkId === 2695) return "Schedule-b9dbda59ea9549dfa18e.css";
	if (chunkId === 3212) return "DemoDrive-b9dbda59ea9549dfa18e.css";
	// return url for filenames based on template
	return undefined;
};